import { useDispatch, useSelector } from 'react-redux';
import { next, back } from '../../../fsm/events';
import { getHighwayPointOfInterests } from '../../../selectors/coreApi';
import { HIGHWAY_POINT_OF_INTEREST_DIGITAL_EXIT, HIGHWAY_POINT_OF_INTEREST_NOT_LISTED } from '../../../ducks/coreApi';
import { getCountry } from '../../../selectors/location';

export const useConnect = () => {
  const dispatch = useDispatch();
  return {
    pointOfInterests: useSelector(getHighwayPointOfInterests),
    country: useSelector(getCountry),
    back: () => dispatch(back()),
    next: payload => dispatch(next(payload)),
    poiDigitalExit: () => dispatch({ type: HIGHWAY_POINT_OF_INTEREST_DIGITAL_EXIT }),
    highwayPOINotListed: () => dispatch({ type: HIGHWAY_POINT_OF_INTEREST_NOT_LISTED }),
  };
};
